import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormatter'
})
export class CurrencyFormatterPipe implements PipeTransform {
  transform(value: number | string): string {
    if (!value) return '';

    let numberValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numberValue)) return value.toString();

    return new Intl.NumberFormat('en-IN').format(numberValue); // Indian-style commas
  }
}
